import type { SubAccess } from "../subscription/useSub";
import type { AppRole, NavItem, NavSection, NavSectionAction } from "./navConfig";
import type { NavBadges } from "./useNavBadges";

export type SectionView = {
  items: NavItem[];
  action: NavSectionAction | null;
  badgeSum: number;
  opensDirectly: NavItem | null;
};

export const sectionView = (
  section: NavSection,
  role: AppRole,
  access: SubAccess,
  badges: NavBadges,
): SectionView | null => {
  const items = section.items
    .filter((item) => item.roles.includes(role) && (!item.access || access[item.access]))
    .map((item) => (access.hasBuyerAccess && item.buyerLabelKey ? { ...item, labelKey: item.buyerLabelKey } : item));
  const candidate = section.action;
  const action =
    candidate != null && candidate.roles.includes(role) && (!candidate.access || access[candidate.access])
      ? candidate
      : null;
  if (items.length === 0 && !action) return null;
  const badgeSum = items.reduce((sum, item) => sum + (item.badgeKey ? badges[item.badgeKey] ?? 0 : 0), 0);
  const opensDirectly = items.length === 1 && !action ? items[0] : null;
  return { items, action, badgeSum, opensDirectly };
};
